// Collapsible content
$(function () {
  $('.acc__title').click(function (j) {

    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.accordion').find('.acc__panel').not(dropDown).slideUp();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.accordion').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }

    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});

// PDP total = unit price × quantity
(function () {
  function formatProductTotal(cents, currencyCode) {
    try {
      return (
        new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode || '',
          currencyDisplay: 'code',
        })
          .format(Number(cents) / 100)
          .replace(/\u00a0/g, ' ') + ' total'
      );
    } catch (e) {
      return (currencyCode || '') + ' ' + (Number(cents) / 100).toFixed(2) + ' total';
    }
  }

  function updateProductTotalPrice(scope) {
    const roots = scope ? [scope] : document.querySelectorAll('product-info');
    roots.forEach((root) => {
      if (!root) return;
      const totalEl = root.querySelector('[data-product-total-price]');
      if (!totalEl) return;
      const qtyInput = root.querySelector('.quantity__input');
      const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      const unit = parseInt(totalEl.getAttribute('data-unit-price') || '0', 10) || 0;
      totalEl.textContent = formatProductTotal(unit * qty, totalEl.getAttribute('data-currency-code'));
    });
  }

  document.addEventListener('change', (event) => {
    if (!event.target || !event.target.classList || !event.target.classList.contains('quantity__input')) return;
    updateProductTotalPrice(event.target.closest('product-info'));
  });

  updateProductTotalPrice();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event && event.data && event.data.variant;
      const sectionId = event && event.data && event.data.sectionId;
      if (!variant || variant.price == null) return;
      const root = sectionId
        ? document.querySelector('product-info[data-section="' + sectionId + '"]')
        : null;
      const targets = root
        ? root.querySelectorAll('[data-product-total-price]')
        : document.querySelectorAll('[data-product-total-price]');
      targets.forEach((el) => el.setAttribute('data-unit-price', String(variant.price)));
      updateProductTotalPrice(root);
    });
    subscribe(PUB_SUB_EVENTS.quantityUpdate, () => updateProductTotalPrice());
  }
})();


// restock custom button
(function () {
  function addRestockClass() {
    document.querySelectorAll('.restock-rocket-button').forEach((button) => {
      const gridItem = button.closest('li.grid__item');

      if (gridItem && !gridItem.classList.contains('restock-vsb')) {
        gridItem.classList.add('restock-vsb');
      }
    });
  }

  // Initial check
  addRestockClass();

  // Watch for dynamically added buttons
  const observer = new MutationObserver(() => {
    addRestockClass();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Quick View: Notify Me above Sold Out (same as PDP)
(function () {
  var productCache = {};

  function getProductInfo(root) {
    if (!root) return null;
    return root.matches?.('product-info') ? root : root.querySelector('product-info');
  }

  function getVariantId(productInfo) {
    return productInfo.querySelector('input.product-variant-id, input[name="id"]')?.value || '';
  }

  function isSoldOut(productInfo) {
    var submit = productInfo.querySelector('.product-form__submit');
    return !!(submit && submit.hasAttribute('disabled'));
  }

  function removeNotify(productInfo) {
    productInfo.querySelectorAll('.quick-add-notify').forEach(function (el) {
      el.remove();
    });
  }

  function fetchProductData(productInfo) {
    var productId = productInfo.dataset.productId;
    if (productId && productCache[productId]) return Promise.resolve(productCache[productId]);

    var url = productInfo.dataset.url;
    if (!url) return Promise.resolve(null);

    return fetch(url.split('?')[0] + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.id) productCache[String(data.id)] = data;
        return data;
      })
      .catch(function () {
        return productId ? { id: Number(productId) } : null;
      });
  }

  function insertNotifyButton(productInfo, productData) {
    var submit = productInfo.querySelector('.product-form__submit');
    var buttons = productInfo.querySelector('.product-form__buttons');
    if (!submit || !buttons || buttons.querySelector('.quick-add-notify')) return;

    var variantId = getVariantId(productInfo);
    var productId = productInfo.dataset.productId;
    var label =
      (window._RestockRocketConfig &&
        window._RestockRocketConfig.settings &&
        window._RestockRocketConfig.settings.storefront_button_text) ||
      'NOTIFY ME';

    var container = document.createElement('div');
    container.className = 'restock-rocket-button-container quick-add-notify';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'restock-rocket-button restock-rocket-button-product';
    button.setAttribute('aria-haspopup', 'dialog');
    button.textContent = label;
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (!window._RestockRocket || typeof window._RestockRocket.openModal !== 'function') return;
      window._RestockRocket.openModal(
        productData || { id: Number(productId) },
        Number(getVariantId(productInfo) || variantId)
      );
    });

    container.appendChild(button);
    submit.insertAdjacentElement('beforebegin', container);
  }

  function syncQuickViewNotifyMe(root) {
    var productInfo = getProductInfo(root);
    if (!productInfo || !productInfo.closest('quick-add-modal')) return;

    if (!isSoldOut(productInfo)) {
      removeNotify(productInfo);
      return;
    }

    fetchProductData(productInfo).then(function (productData) {
      if (!productInfo.isConnected || !isSoldOut(productInfo)) {
        removeNotify(productInfo);
        return;
      }
      insertNotifyButton(productInfo, productData);
    });
  }

  window.__syncQuickViewNotifyMe = syncQuickViewNotifyMe;
})();

// Product media gallery swipe:
// - Touch: native scroll-snap (no custom drag = no jerk)
// - Mouse: custom drag + one clean snap on release
(function () {
  const SELECTOR = '.product__media-list.slider';
  const DRAG_THRESHOLD = 6;
  const FLICK_VELOCITY = 0.4;
  let state = null;

  function getSlides(slider) {
    return Array.from(slider.querySelectorAll('.slider__slide')).filter((el) => el.clientWidth > 0);
  }

  function isGallerySlider(node) {
    return !!(node && node.matches && node.matches(SELECTOR) && !node.classList.contains('thumbnail-list'));
  }

  function snapToNearest(slider, velocityX) {
    const slides = getSlides(slider);
    if (slides.length < 2) return;

    let nearest = 0;
    let minDist = Infinity;
    slides.forEach((slide, index) => {
      const dist = Math.abs(slide.offsetLeft - slider.scrollLeft);
      if (dist < minDist) {
        minDist = dist;
        nearest = index;
      }
    });

    if (velocityX < -FLICK_VELOCITY && nearest < slides.length - 1) nearest += 1;
    else if (velocityX > FLICK_VELOCITY && nearest > 0) nearest -= 1;

    const target = slides[Math.max(0, Math.min(slides.length - 1, nearest))];
    // Snap while .is-dragging keeps scroll-snap off — avoids double-snap jerk
    slider.scrollLeft = target.offsetLeft;
  }

  function endDrag(event) {
    if (!state) return;
    if (event && event.pointerId !== state.pointerId) return;

    const { slider, moved, captured, pointerId, velocityX } = state;
    state = null;

    if (captured) {
      try {
        slider.releasePointerCapture(pointerId);
      } catch (e) {}
    }

    if (moved) {
      snapToNearest(slider, velocityX || 0);
      slider.dataset.suppressClick = 'true';
      window.setTimeout(() => {
        delete slider.dataset.suppressClick;
      }, 250);
    }

    // Re-enable snap after scrollLeft is set
    window.requestAnimationFrame(() => {
      slider.classList.remove('is-dragging');
      const component = slider.closest('slider-component');
      if (component && typeof component.update === 'function') component.update();
    });
  }

  document.addEventListener('pointerdown', (event) => {
    // Touch/pen: let browser handle native swipe
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (event.button != null && event.button !== 0) return;

    const slider = event.target.closest && event.target.closest(SELECTOR);
    if (!isGallerySlider(slider)) return;
    if (event.target.closest('.slider-button, a[href], input, select, textarea, button:not(.product__media-toggle)')) {
      return;
    }

    state = {
      slider: slider,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startScroll: slider.scrollLeft,
      moved: false,
      axis: null,
      captured: false,
      lastX: event.clientX,
      lastTime: event.timeStamp || performance.now(),
      velocityX: 0,
    };
  });

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!state || event.pointerId !== state.pointerId) return;

      const dx = event.clientX - state.startX;
      const dy = event.clientY - state.startY;
      const now = event.timeStamp || performance.now();
      const dt = Math.max(1, now - state.lastTime);
      state.velocityX = (event.clientX - state.lastX) / dt;
      state.lastX = event.clientX;
      state.lastTime = now;

      if (!state.axis) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          state = null;
          return;
        }
        state.axis = 'x';
        state.slider.classList.add('is-dragging');
        try {
          state.slider.setPointerCapture(state.pointerId);
          state.captured = true;
        } catch (e) {}
      }

      if (state.axis !== 'x') return;
      state.moved = true;
      event.preventDefault();
      state.slider.scrollLeft = state.startScroll - dx;
    },
    { passive: false }
  );

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener(
    'click',
    (event) => {
      const slider = event.target.closest && event.target.closest(SELECTOR);
      if (!slider || slider.dataset.suppressClick !== 'true') return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  function resetGallerySlider(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach((slider) => {
      if (!isGallerySlider(slider)) return;
      const component = slider.closest('slider-component');
      if (component && typeof component.resetPages === 'function') component.resetPages();
    });
  }

  window.initProductGallerySwipe = resetGallerySlider;

  document.addEventListener('shopify:section:load', (event) => {
    resetGallerySlider(event.target);
  });
})();



// rebuy start
document.addEventListener('DOMContentLoaded', function () {

  const addIcon = `
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_449_6664)">
        <path d="M8.71741 1.16699H2.5L0.75 3.50033V11.667C0.75 11.9764 0.872916 12.2732 1.09171 12.4919C1.3105 12.7107 1.60725 12.8337 1.91667 12.8337H10.0833C10.3928 12.8337 10.6895 12.7107 10.9083 12.4919C11.1271 12.2732 11.25 11.9764 11.25 11.667V5.94475"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"></path>

        <path d="M0.75 3.5H7.30187"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"></path>

        <path d="M8.33268 5.83301C8.33268 6.45185 8.08685 7.04534 7.64926 7.48292C7.21168 7.92051 6.61819 8.16634 5.99935 8.16634C5.38051 8.16634 4.78702 7.92051 4.34943 7.48292C3.91185 7.04534 3.66602 6.45185 3.66602 5.83301"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"></path>

        <path d="M9.68848 2.73926H12.8652"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"></path>

        <path d="M11.2744 4.3291L11.2744 1.15234"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"></path>
      </g>

      <defs>
        <clipPath id="clip0_449_6664">
          <rect width="14" height="14" fill="currentColor"></rect>
        </clipPath>
      </defs>
    </svg>
    <span class="button-text">Add</span>
  `;

  function updateRebuyButtons() {
    document.querySelectorAll('.rebuy-widget .rebuy-button').forEach(function(button) {

      // Already updated
      if (button.classList.contains('custom-add-button')) return;

      button.innerHTML = addIcon;
      button.classList.add('custom-add-button');

    });
  }

  // Initial
  updateRebuyButtons();

  // Rebuy dynamically products/buttons render karta hai
  const observer = new MutationObserver(function() {
    updateRebuyButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

// rebuy close


// Rebuy upsell ATC: tag-gated line item properties + Partial Pay selling_plan (Advanced Preorder).
(function () {
  if (window.__rebuyTagPropertiesBound) return;
  window.__rebuyTagPropertiesBound = true;

  var rebuyProductJsonCache = {};

  function getTagList(product) {
    var tags = product && product.tags;
    if (!tags) return [];
    if (Array.isArray(tags)) {
      return tags.map(function (tag) {
        return String(tag).trim();
      });
    }
    return String(tags)
      .split(',')
      .map(function (tag) {
        return tag.trim();
      });
  }

  function hasTag(tags, tag) {
    return tags.indexOf(tag) !== -1;
  }

  function getSelectedVariant(product) {
    if (!product) return null;
    if (product.selected_variant) return product.selected_variant;
    if (product.variant) return product.variant;
    var variantId = product.variant_id || product.id;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (Number(variants[i].id) === Number(variantId)) return variants[i];
    }
    return variants[0] || null;
  }

  function getPriceCents(product) {
    var variant = getSelectedVariant(product);
    var price = variant && variant.price != null ? variant.price : product && product.price;
    if (price == null || price === '') return 0;
    if (typeof price === 'string' && price.indexOf('.') !== -1) {
      return Math.round(parseFloat(price) * 100);
    }
    return Math.round(Number(price) || 0);
  }

  function formatEstimatedPrice(cents) {
    if (typeof window.plantinFormatMoney === 'function') {
      return window.plantinFormatMoney(cents);
    }
    var value = Math.max(0, Math.round(Number(cents) || 0));
    var amount = (value / 100).toFixed(2);
    var localized = Number(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    var format = window.shopMoneyWithCurrencyFormat;
    if (typeof format === 'string' && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, localized.replace(/,/g, '.').replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value / 100)))
        .replace(/\{\{\s*amount\s*\}\}/g, localized);
    }
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    return (currency ? currency + ' ' : '') + localized;
  }

  function buildTagProperties(product) {
    var tags = getTagList(product);
    var properties = {};

    if (hasTag(tags, 'PT: Black Truffle') || hasTag(tags, 'PT: White Truffle')) {
      properties['Final invoice'] = 'sent on delivery date';
      properties['Estimated Price'] = formatEstimatedPrice(getPriceCents(product));
    }

    if (
      hasTag(tags, 'cat:meat-poultry') &&
      hasTag(tags, 'fmt:fresh') &&
      hasTag(tags, 'attr:pre-order') &&
      typeof window.__getHktNextShipment === 'function'
    ) {
      properties['Pre-order'] = window.__getHktNextShipment(new Date()).preOrderLabel;
    }

    return properties;
  }

  function assignMissingProperties(target, extra) {
    if (!target || !extra) return target;
    Object.keys(extra).forEach(function (key) {
      if (target[key] == null || target[key] === '') target[key] = extra[key];
    });
    return target;
  }

  function getVariantById(product, variantId) {
    if (!product || !variantId) return null;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (Number(variants[i].id) === Number(variantId)) return variants[i];
    }
    return getSelectedVariant(product);
  }

  function isPartialPayProduct(product) {
    if (!product) return false;
    var tags = getTagList(product);
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === 'sd_partial') return true;
    }
    var groups = product.selling_plan_groups || [];
    for (var j = 0; j < groups.length; j++) {
      if (/partial/i.test(String(groups[j].name || ''))) return true;
    }
    return false;
  }

  function getPartialPayGroup(product) {
    var groups = product.selling_plan_groups || [];
    for (var i = 0; i < groups.length; i++) {
      if (/partial/i.test(String(groups[i].name || ''))) return groups[i];
    }
    return null;
  }

  function getPartialPayPlanId(product, variantId) {
    var group = getPartialPayGroup(product);
    if (!group) return null;
    var variant = getVariantById(product, variantId);
    var allocations = (variant && variant.selling_plan_allocations) || [];
    for (var i = 0; i < allocations.length; i++) {
      if (String(allocations[i].selling_plan_group_id) === String(group.id)) {
        return allocations[i].selling_plan_id;
      }
    }
    if (group.selling_plans && group.selling_plans.length) {
      return group.selling_plans[0].id;
    }
    return null;
  }

  function getVariantPriceDollars(variant) {
    if (!variant || variant.price == null) return 0;
    var price = variant.price;
    if (typeof price === 'string' && price.indexOf('.') !== -1) {
      return parseFloat(price) || 0;
    }
    return (Number(price) || 0) / 100;
  }

  function buildPartialPayProperties(product, variantId) {
    var variant = getVariantById(product, variantId);
    var remaining = getVariantPriceDollars(variant);
    return {
      '_PRE-ORDER DEPOSIT': '0.00',
      '_REMAINING BALANCE': remaining.toFixed(2),
      _is_selling_plan: 'true',
    };
  }

  var partialPayPlanByVariant = {};

  function needsFullProductJson(product) {
    if (!product || !product.handle) return false;
    if (!isPartialPayProduct(product)) return false;
    var variant = getSelectedVariant(product);
    var allocations = (variant && variant.selling_plan_allocations) || [];
    return !allocations.length;
  }

  function fetchRebuyProductJson(product) {
    if (!product) return Promise.resolve(null);
    var handle = product.handle;
    if (handle && rebuyProductJsonCache[handle] && !needsFullProductJson(product)) {
      return Promise.resolve(rebuyProductJsonCache[handle]);
    }
    if (
      product.selling_plan_groups &&
      product.selling_plan_groups.length &&
      !needsFullProductJson(product)
    ) {
      if (handle) rebuyProductJsonCache[handle] = product;
      return Promise.resolve(product);
    }
    if (!handle) return Promise.resolve(product);
    if (rebuyProductJsonCache[handle] && !needsFullProductJson(rebuyProductJsonCache[handle])) {
      return Promise.resolve(rebuyProductJsonCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (response) {
        return response.ok ? response.json() : product;
      })
      .then(function (full) {
        rebuyProductJsonCache[handle] = full || product;
        return rebuyProductJsonCache[handle];
      })
      .catch(function () {
        return product;
      });
  }

  function cachePartialPayPlansFromProduct(product) {
    return fetchRebuyProductJson(product).then(function (full) {
      if (!full || !isPartialPayProduct(full)) return full;
      (full.variants || []).forEach(function (variant) {
        var planId = getPartialPayPlanId(full, variant.id);
        if (!planId) return;
        partialPayPlanByVariant[String(variant.id)] = {
          planId: planId,
          product: full,
        };
      });
      return full;
    });
  }

  function applyPartialPayToTarget(target, product, variantId, planId) {
    if (!target || !planId) return false;
    if (target.selling_plan || target.selling_plan_id) return false;
    target.selling_plan = planId;
    target.selling_plan_id = planId;
    target.properties = assignMissingProperties(
      target.properties || {},
      buildPartialPayProperties(product, variantId)
    );
    return true;
  }

  function applyPartialPayFromCache(target, variantId) {
    if (!target || !variantId) return false;
    var cached = partialPayPlanByVariant[String(variantId)];
    if (!cached) return false;
    return applyPartialPayToTarget(target, cached.product, variantId, cached.planId);
  }

  function applyPartialPayToProduct(product) {
    if (!product) return Promise.resolve(product);
    var variantId = (getSelectedVariant(product) && getSelectedVariant(product).id) || product.variant_id;
    if (!variantId) return Promise.resolve(product);
    if (product.selling_plan || product.selling_plan_id) return Promise.resolve(product);
    if (applyPartialPayFromCache(product, variantId)) return Promise.resolve(product);

    return cachePartialPayPlansFromProduct(product).then(function (full) {
      if (applyPartialPayFromCache(product, variantId)) return product;
      if (!full || !isPartialPayProduct(full)) return product;
      var planId = getPartialPayPlanId(full, variantId);
      applyPartialPayToTarget(product, full, variantId, planId);
      return product;
    });
  }

  function applyPartialPayToItem(item, product) {
    if (!item) return Promise.resolve(item);
    var variantId = item.id || item.variant_id;
    if (!variantId) return Promise.resolve(item);
    if (item.selling_plan || item.selling_plan_id) return Promise.resolve(item);
    if (applyPartialPayFromCache(item, variantId)) return Promise.resolve(item);

    var resolvedProduct = product || findRebuyProductByVariantId(variantId) || item.product;
    return cachePartialPayPlansFromProduct(resolvedProduct).then(function (prod) {
      if (applyPartialPayFromCache(item, variantId)) return item;
      prod = prod || resolvedProduct;
      if (!prod || !isPartialPayProduct(prod)) return item;
      var planId = getPartialPayPlanId(prod, variantId);
      applyPartialPayToTarget(item, prod, variantId, planId);
      return item;
    });
  }

  function prefetchRebuyPartialPayProducts() {
    if (!window.Rebuy || !Array.isArray(Rebuy.widgets)) return;
    Rebuy.widgets.forEach(function (widget) {
      var products =
        (widget && widget.data && widget.data.products) ||
        (widget && widget.products) ||
        [];
      products.forEach(function (product) {
        if (isPartialPayProduct(product)) cachePartialPayPlansFromProduct(product);
      });
    });
  }

  function mergePartialPayIntoCartAddPayload(payload) {
    if (!payload) return payload;

    function enrichLine(line) {
      if (!line) return;
      var variantId = line.id || line.variant_id;
      if (!variantId || line.selling_plan || line.selling_plan_id) return;
      applyPartialPayFromCache(line, variantId);
    }

    if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      if (payload.get('selling_plan')) return payload;
      var variantId = payload.get('id');
      if (!variantId) return payload;
      var cached = partialPayPlanByVariant[String(variantId)];
      if (!cached) return payload;
      payload.set('selling_plan', cached.planId);
      var props = buildPartialPayProperties(cached.product, variantId);
      Object.keys(props).forEach(function (key) {
        var flat = 'properties[' + key + ']';
        if (!payload.get(flat)) payload.set(flat, props[key]);
      });
      return payload;
    }

    if (typeof payload === 'string') {
      try {
        return JSON.stringify(mergePartialPayIntoCartAddPayload(JSON.parse(payload)));
      } catch (e) {
        try {
          var params = new URLSearchParams(payload);
          if (params.get('selling_plan')) return payload;
          var formVariantId = params.get('id');
          if (!formVariantId) return payload;
          var formCached = partialPayPlanByVariant[String(formVariantId)];
          if (!formCached) return payload;
          params.set('selling_plan', formCached.planId);
          var formProps = buildPartialPayProperties(formCached.product, formVariantId);
          Object.keys(formProps).forEach(function (key) {
            var propKey = 'properties[' + key + ']';
            if (!params.get(propKey)) params.set(propKey, formProps[key]);
          });
          return params.toString();
        } catch (err) {
          return payload;
        }
      }
    }

    if (typeof payload === 'object') {
      if (Array.isArray(payload.items)) {
        payload.items.forEach(enrichLine);
        return payload;
      }
      enrichLine(payload);
    }

    return payload;
  }

  function getVariantIdsFromCartAddPayload(payload) {
    var ids = [];
    if (!payload) return ids;

    if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      var formId = payload.get('id');
      if (formId) ids.push(formId);
      return ids;
    }

    if (typeof payload === 'string') {
      try {
        return getVariantIdsFromCartAddPayload(JSON.parse(payload));
      } catch (e) {
        try {
          var params = new URLSearchParams(payload);
          if (params.get('id')) ids.push(params.get('id'));
        } catch (err) {}
        return ids;
      }
    }

    if (typeof payload === 'object') {
      if (Array.isArray(payload.items)) {
        payload.items.forEach(function (item) {
          if (item && (item.id || item.variant_id)) ids.push(item.id || item.variant_id);
        });
      } else if (payload.id || payload.variant_id) {
        ids.push(payload.id || payload.variant_id);
      }
    }

    return ids;
  }

  function ensurePartialPayCacheForPayload(payload) {
    var variantIds = getVariantIdsFromCartAddPayload(payload);
    if (!variantIds.length) return Promise.resolve();

    var tasks = variantIds.map(function (variantId) {
      if (partialPayPlanByVariant[String(variantId)]) return Promise.resolve();
      var product = findRebuyProductByVariantId(variantId);
      if (!product) return Promise.resolve();
      return cachePartialPayPlansFromProduct(product);
    });

    return Promise.all(tasks);
  }

  function hookRebuyCartAddFetch() {
    if (window.__rebuyPartialPayCartHooked) return;
    window.__rebuyPartialPayCartHooked = true;

    if (typeof window.fetch === 'function') {
      var originalFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (!/\/cart\/add/i.test(url) || !init || init.body == null) {
          return originalFetch(input, init);
        }

        return ensurePartialPayCacheForPayload(init.body).then(function () {
          var nextInit = Object.assign({}, init, {
            body: mergePartialPayIntoCartAddPayload(init.body),
          });
          return originalFetch(input, nextInit);
        });
      };
    }

    if (window.jQuery && jQuery.ajax) {
      var originalAjax = jQuery.ajax;
      jQuery.ajax = function (url, options) {
        var settings = typeof url === 'object' ? url : options;
        var requestUrl = typeof url === 'string' ? url : (settings && settings.url) || '';
        if (settings && /\/cart\/add/i.test(String(requestUrl))) {
          var merged = Object.assign({}, settings, {
            data: mergePartialPayIntoCartAddPayload(settings.data),
          });
          if (typeof url === 'object') return originalAjax.call(this, merged);
          return originalAjax.call(this, url, merged);
        }
        return originalAjax.apply(this, arguments);
      };
    }
  }

  function wrapWidgetAddToCart(widget) {
    if (!widget || typeof widget.addToCart !== 'function' || widget.addToCart.__plantinPartialPay) return;

    var original = widget.addToCart.bind(widget);
    widget.addToCart = function (product, callback) {
      applyPropertiesToProduct(product);
      return applyPartialPayToProduct(product).then(function () {
        return original(product, callback);
      });
    };
    widget.addToCart.__plantinPartialPay = true;
  }

  function wrapAllWidgetAddToCart() {
    if (!window.Rebuy || !Array.isArray(Rebuy.widgets)) return;
    Rebuy.widgets.forEach(wrapWidgetAddToCart);
  }

  function enableRebuySellingPlans() {
    if (window.Rebuy && Rebuy.shop) {
      Rebuy.shop.shopify_selling_plans_enabled = true;
    }
  }

  function applyPropertiesToProduct(product) {
    if (!product) return;
    var extra = buildTagProperties(product);
    if (!Object.keys(extra).length) return;
    product.properties = assignMissingProperties(product.properties || {}, extra);
  }

  function findRebuyProductByVariantId(variantId) {
    if (!variantId || !window.Rebuy || !Array.isArray(Rebuy.widgets)) return null;
    for (var i = 0; i < Rebuy.widgets.length; i++) {
      var widget = Rebuy.widgets[i];
      var products =
        (widget && widget.data && widget.data.products) ||
        (widget && widget.products) ||
        [];
      for (var j = 0; j < products.length; j++) {
        var product = products[j];
        var variant = getSelectedVariant(product);
        if (variant && Number(variant.id) === Number(variantId)) return product;
        var variants = product.variants || [];
        for (var k = 0; k < variants.length; k++) {
          if (Number(variants[k].id) === Number(variantId)) return product;
        }
      }
    }
    return null;
  }

  function applyPropertiesToAddPayload(item) {
    if (!item) return item;
    var variantId = item.id || item.variant_id;
    var product = findRebuyProductByVariantId(variantId) || item.product || item;
    var extra = buildTagProperties(product);
    if (!Object.keys(extra).length) return item;
    item.properties = assignMissingProperties(item.properties || {}, extra);
    return item;
  }

  function enrichRebuyAddPayload(item) {
    var tasks = [];
    function enrichOne(cartItem) {
      if (!cartItem) return Promise.resolve();
      applyPropertiesToAddPayload(cartItem);
      var variantId = cartItem.id || cartItem.variant_id;
      var product =
        findRebuyProductByVariantId(variantId) || cartItem.product || (item && item.product);
      return applyPartialPayToItem(cartItem, product);
    }

    if (Array.isArray(item)) {
      tasks = item.map(enrichOne);
    } else if (item && item.items && Array.isArray(item.items)) {
      tasks = item.items.map(enrichOne);
    } else {
      tasks = [enrichOne(item)];
    }

    return Promise.all(tasks);
  }

  function wrapCartAddItem() {
    if (!window.Rebuy || !Rebuy.Cart || typeof Rebuy.Cart.addItem !== 'function') return;
    if (Rebuy.Cart.addItem.__plantinTagProps) return;

    var original = Rebuy.Cart.addItem.bind(Rebuy.Cart);
    Rebuy.Cart.addItem = function (item, callback) {
      return enrichRebuyAddPayload(item).then(function () {
        return original(item, callback);
      });
    };
    Rebuy.Cart.addItem.__plantinTagProps = true;
  }

  document.addEventListener('rebuy.beforeAdd', function (event) {
    var detail = event.detail || {};
    var product = detail.product;
    if (!product) return;

    applyPropertiesToProduct(product);
    applyPartialPayToProduct(product);

    if (detail.item) {
      applyPropertiesToAddPayload(detail.item);
      applyPartialPayToItem(detail.item, product);
    }
  });

  document.addEventListener('rebuy.productsChange', function (event) {
    var detail = event.detail || {};
    var products = detail.products || [];
    products.forEach(function (product) {
      if (isPartialPayProduct(product)) cachePartialPayPlansFromProduct(product);
    });
  });

  enableRebuySellingPlans();
  hookRebuyCartAddFetch();
  wrapCartAddItem();
  wrapAllWidgetAddToCart();
  document.addEventListener('rebuy.loaded', enableRebuySellingPlans);
  document.addEventListener('rebuy.ready', function () {
    enableRebuySellingPlans();
    prefetchRebuyPartialPayProducts();
    wrapCartAddItem();
    wrapAllWidgetAddToCart();
  });
  document.addEventListener('rebuy:cart.ready', function () {
    enableRebuySellingPlans();
    prefetchRebuyPartialPayProducts();
    wrapCartAddItem();
    wrapAllWidgetAddToCart();
  });
})();


// PDP + Quick View: inject tag-gated line item properties (truffle Estimated Price, Pre-order)
(function () {
  if (window.__pdpTagPropertiesBound) return;
  window.__pdpTagPropertiesBound = true;

  var productCache = null;
  var quickViewProductCache = {};
  var injectTimer = null;
  var FORCE_PROPERTY_KEYS = { Invoice: true, 'Estimated Price': true, 'Pre-order': true };

  function isProductPage() {
    return /\/products\//.test(window.location.pathname || '');
  }

  function getTagList(product) {
    var tags = product && product.tags;
    if (!tags) return [];
    if (Array.isArray(tags)) {
      return tags.map(function (tag) {
        return String(tag).trim();
      });
    }
    return String(tags)
      .split(',')
      .map(function (tag) {
        return tag.trim();
      });
  }

  function hasTag(tags, tag) {
    return tags.indexOf(tag) !== -1;
  }

  function getSelectedVariantId(form) {
    var input =
      (form && form.querySelector('input[name="id"], select[name="id"]')) ||
      document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    if (input && input.value) return String(input.value);
    try {
      var urlVariant = new URL(window.location.href).searchParams.get('variant');
      if (urlVariant) return String(urlVariant);
    } catch (e) {}
    if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.selectedVariantId) {
      return String(ShopifyAnalytics.meta.selectedVariantId);
    }
    return '';
  }

  function getVariantById(product, variantId) {
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    return variants[0] || null;
  }

  function formatEstimatedPrice(cents) {
    if (typeof window.plantinFormatMoney === 'function') {
      return window.plantinFormatMoney(cents);
    }
    var value = Math.max(0, Math.round(Number(cents) || 0));
    var amount = (value / 100).toFixed(2);
    var localized = Number(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    var format = window.shopMoneyWithCurrencyFormat;
    if (typeof format === 'string' && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, localized.replace(/,/g, '.').replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value / 100)))
        .replace(/\{\{\s*amount\s*\}\}/g, localized);
    }
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    return (currency ? currency + ' ' : '') + localized;
  }

  function buildTagProperties(product, form) {
    if (!product) return {};
    var tags = getTagList(product);
    var properties = {};

    if (hasTag(tags, 'PT: Black Truffle') || hasTag(tags, 'PT: White Truffle')) {
      var variant = getVariantById(product, getSelectedVariantId(form));
      var cents = variant && variant.price != null ? Number(variant.price) : Number(product.price) || 0;
      properties['Final invoice'] = 'sent on delivery date';
      properties['Estimated Price'] = formatEstimatedPrice(cents);
    }

    if (
      hasTag(tags, 'cat:meat-poultry') &&
      hasTag(tags, 'fmt:fresh') &&
      hasTag(tags, 'attr:pre-order') &&
      typeof window.__getHktNextShipment === 'function'
    ) {
      properties['Pre-order'] = window.__getHktNextShipment(new Date()).preOrderLabel;
    }

    return properties;
  }

  function ensureHiddenProperty(form, key, value) {
    if (!form || value == null || value === '') return;
    var name = 'properties[' + key + ']';
    var input = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');
    if (!input) {
      // querySelector with brackets can be awkward — fall back to scan
      var inputs = form.querySelectorAll('input[name^="properties["]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].name === name) {
          input = inputs[i];
          break;
        }
      }
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-plantin-tag-property', key);
      form.appendChild(input);
    }
    input.value = value;
    input.disabled = false;
  }

  function injectPropertiesIntoForm(product, form) {
    if (!product || !form) return;
    var props = buildTagProperties(product, form);
    Object.keys(props).forEach(function (key) {
      ensureHiddenProperty(form, key, props[key]);
    });
  }

  function injectPropertiesIntoForms(product) {
    if (!product) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      injectPropertiesIntoForm(product, form);
    });
  }

  function getProductInfoFromRoot(root) {
    if (!root) return null;
    if (root.matches && root.matches('product-info')) return root;
    return root.querySelector ? root.querySelector('product-info') : null;
  }

  function loadProductByUrl(url) {
    if (!url) return Promise.resolve(null);
    var key = url.split('?')[0];
    if (quickViewProductCache[key]) return Promise.resolve(quickViewProductCache[key]);
    return fetch(key + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        quickViewProductCache[key] = data;
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function getQuickViewContext() {
    var modal = document.querySelector('quick-add-modal[open]');
    if (!modal) return null;
    var productInfo = modal.querySelector('product-info');
    var form =
      productInfo &&
      (productInfo.querySelector('form[data-type="add-to-cart-form"]') ||
        productInfo.querySelector('product-form form[data-type="add-to-cart-form"]'));
    if (!productInfo || !form) return null;
    var url = (productInfo.dataset.url || '').split('?')[0];
    var product = quickViewProductCache[url] || null;
    return { product: product, form: form, productInfo: productInfo, url: url };
  }

  function scheduleQuickViewInject(productInfo, product) {
    [350, 800].forEach(function (delay) {
      setTimeout(function () {
        if (!productInfo || !productInfo.isConnected || !product) return;
        var form =
          productInfo.querySelector('form[data-type="add-to-cart-form"]') ||
          productInfo.querySelector('product-form form[data-type="add-to-cart-form"]');
        injectPropertiesIntoForm(product, form);
      }, delay);
    });
  }

  function syncQuickViewTagProperties(root, variantId) {
    var productInfo = getProductInfoFromRoot(root);
    if (!productInfo || !productInfo.closest('quick-add-modal')) return Promise.resolve();

    var form =
      productInfo.querySelector('form[data-type="add-to-cart-form"]') ||
      productInfo.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (variantId && form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = String(variantId);
    }

    var url = (productInfo.dataset.url || '').split('?')[0];
    return loadProductByUrl(url).then(function (product) {
      if (!productInfo.isConnected || !product) return;
      injectPropertiesIntoForm(product, form);
      scheduleQuickViewInject(productInfo, product);
    });
  }

  window.__syncQuickViewTagProperties = syncQuickViewTagProperties;

  function scheduleInject(product) {
    clearTimeout(injectTimer);
    injectTimer = setTimeout(function () {
      injectPropertiesIntoForms(product || productCache);
    }, 50);
  }

  function loadProduct() {
    if (productCache) return Promise.resolve(productCache);
    var path = (window.location.pathname || '').split('?')[0];
    if (!/\/products\//.test(path)) return Promise.resolve(null);
    return fetch(path + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        productCache = data;
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function mergePropertiesIntoPayload(payload, props) {
    if (!payload || !props || !Object.keys(props).length) return payload;

    if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      Object.keys(props).forEach(function (key) {
        var name = 'properties[' + key + ']';
        var current = payload.get(name);
        if (FORCE_PROPERTY_KEYS[key] || current == null || current === '') {
          payload.set(name, props[key]);
        }
      });
      return payload;
    }

    if (typeof payload === 'string') {
      try {
        return JSON.stringify(mergePropertiesIntoPayload(JSON.parse(payload), props));
      } catch (e) {
        try {
          var params = new URLSearchParams(payload);
          Object.keys(props).forEach(function (key) {
            var name = 'properties[' + key + ']';
            var current = params.get(name);
            if (FORCE_PROPERTY_KEYS[key] || current == null || current === '') {
              params.set(name, props[key]);
            }
          });
          return params.toString();
        } catch (err) {
          return payload;
        }
      }
    }

    if (typeof payload === 'object') {
      if (Array.isArray(payload.items)) {
        payload.items.forEach(function (item) {
          item.properties = item.properties || {};
          Object.keys(props).forEach(function (key) {
            if (FORCE_PROPERTY_KEYS[key] || item.properties[key] == null || item.properties[key] === '') {
              item.properties[key] = props[key];
            }
          });
        });
        return payload;
      }
      payload.properties = payload.properties || {};
      Object.keys(props).forEach(function (key) {
        if (FORCE_PROPERTY_KEYS[key] || payload.properties[key] == null || payload.properties[key] === '') {
          payload.properties[key] = props[key];
        }
      });
      // Also support flattened properties[Key] style (jQuery serialize)
      Object.keys(props).forEach(function (key) {
        var flat = 'properties[' + key + ']';
        if (FORCE_PROPERTY_KEYS[key] || payload[flat] == null || payload[flat] === '') {
          payload[flat] = props[key];
        }
      });
    }

    return payload;
  }

  function collectFormProperties(form) {
    var props = {};
    if (!form) return props;
    form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(
      function (el) {
        if (!el.name || el.disabled) return;
        var match = el.name.match(/^properties\[(.+)\]$/);
        if (!match) return;
        if (el.value != null && el.value !== '') props[match[1]] = el.value;
      }
    );
    return props;
  }

  function getQuickViewAddForm() {
    var modal = document.querySelector('quick-add-modal[open]');
    if (!modal) return null;
    return (
      modal.querySelector('form[data-type="add-to-cart-form"]') ||
      modal.querySelector('product-form form[data-type="add-to-cart-form"]')
    );
  }

  function mergeQuickViewFormExtras(payload) {
    var form = getQuickViewAddForm();
    if (!form) return payload;

    var props = collectFormProperties(form);
    var quickView = getQuickViewContext();
    if (quickView && quickView.product) {
      props = Object.assign({}, props, buildTagProperties(quickView.product, form));
    }
    payload = mergePropertiesIntoPayload(payload, props);

    var planInput = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
    if (!planInput || !planInput.value) return payload;

    if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      if (!payload.get('selling_plan')) payload.set('selling_plan', planInput.value);
      return payload;
    }

    if (typeof payload === 'string') {
      try {
        var json = JSON.parse(payload);
        if (!json.selling_plan) json.selling_plan = planInput.value;
        return JSON.stringify(json);
      } catch (e) {
        try {
          var params = new URLSearchParams(payload);
          if (!params.get('selling_plan')) params.set('selling_plan', planInput.value);
          return params.toString();
        } catch (err) {
          return payload;
        }
      }
    }

    if (payload && typeof payload === 'object') {
      if (!payload.selling_plan) payload.selling_plan = planInput.value;
    }

    return payload;
  }

  function propsForCurrentProduct() {
    var quickView = getQuickViewContext();
    if (quickView) {
      var formProps = collectFormProperties(quickView.form);
      var tagProps = quickView.product ? buildTagProperties(quickView.product, quickView.form) : {};
      return Object.assign({}, formProps, tagProps);
    }
    if (!productCache) return {};
    var form = document.querySelector('form[action*="/cart/add"]');
    return buildTagProperties(productCache, form);
  }

  function hookCartAdd() {
    if (window.__pdpTagPropertiesCartHooked) return;
    window.__pdpTagPropertiesCartHooked = true;

    if (typeof window.fetch === 'function') {
      var originalFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add/i.test(url) && init) {
          init = Object.assign({}, init);
          init.body = mergeQuickViewFormExtras(init.body);
          var props = propsForCurrentProduct();
          if (Object.keys(props).length) {
            init.body = mergePropertiesIntoPayload(init.body, props);
          }
        }
        return originalFetch(input, init);
      };
    }

    if (window.jQuery && jQuery.ajax) {
      var originalAjax = jQuery.ajax;
      jQuery.ajax = function (url, options) {
        var settings = typeof url === 'object' ? url : options;
        var requestUrl = typeof url === 'string' ? url : (settings && settings.url) || '';
        if (settings && /\/cart\/add/i.test(String(requestUrl))) {
          var merged = Object.assign({}, settings, {
            data: mergeQuickViewFormExtras(settings.data),
          });
          var props = propsForCurrentProduct();
          if (Object.keys(props).length) {
            merged.data = mergePropertiesIntoPayload(merged.data, props);
          }
          if (typeof url === 'object') return originalAjax.call(this, merged);
          return originalAjax.call(this, url, merged);
        }
        return originalAjax.apply(this, arguments);
      };
    }
  }

  function boot() {
    if (!isProductPage()) return;
    loadProduct().then(function (product) {
      if (!product) return;
      injectPropertiesIntoForms(product);

      document.addEventListener('change', function (event) {
        if (!event.target) return;
        if (event.target.matches && event.target.matches('input[name="id"], select[name="id"], input[name="quantity"]')) {
          scheduleInject(product);
        }
        // Variant radios / swatches often change a hidden id input
        if (event.target.closest && event.target.closest('variant-selects, variant-radios, .product-form')) {
          scheduleInject(product);
        }
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          scheduleInject(product);
        });
      }

      var formRoot = document.querySelector('product-info, form[action*="/cart/add"]');
      if (formRoot && !formRoot.dataset.plantinTagPropsObserved) {
        formRoot.dataset.plantinTagPropsObserved = 'true';
        new MutationObserver(function () {
          scheduleInject(product);
        }).observe(formRoot, { childList: true, subtree: true });
      }
    });
  }

  hookCartAdd();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      var sectionId = event && event.data && event.data.sectionId;
      var productInfo = sectionId
        ? document.querySelector('product-info[data-section="' + sectionId + '"]')
        : null;
      if (productInfo && productInfo.closest('quick-add-modal')) {
        syncQuickViewTagProperties(productInfo, variant && variant.id);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


// Dawn pill radios do not match Advanced Preorder's variantselector1, so the app never
// re-runs maincaller on variant change and PAY PARTIAL stays stuck on the first variant.
// Bridge: after Dawn variantChange, call the app's maincaller. Quick view needs scoped
// form selectors + product variant layer because the app only auto-inits on PDP.
(function () {
  if (window.__partialPayVariantBridgeBound) return;
  window.__partialPayVariantBridgeBound = true;

  var partialPayProductCache = {};
  var partialPayHtmlCache = {};
  var QUICKVIEW_FORM_CLASS = 'sd-partial-pay-quickview-form';
  var savedPartialPayGlobals = null;
  var originalDeveloperSettings = null;

  function getOriginalDeveloperSettings() {
    if (typeof developersetting === 'undefined' || !developersetting) return null;
    if (
      !originalDeveloperSettings &&
      developersetting.formselector &&
      developersetting.formselector.indexOf('quick-add-modal') === -1
    ) {
      originalDeveloperSettings = {
        formselector: developersetting.formselector,
        buttonselector: developersetting.buttonselector,
        variantselector3: developersetting.variantselector3,
      };
    }
    return originalDeveloperSettings;
  }

  function restoreDeveloperSettings() {
    var saved = getOriginalDeveloperSettings();
    if (!saved || typeof developersetting === 'undefined' || !developersetting) return;
    developersetting.formselector = saved.formselector;
    developersetting.buttonselector = saved.buttonselector;
    developersetting.variantselector3 = saved.variantselector3;
  }

  function savePartialPayGlobals() {
    if (savedPartialPayGlobals) return;
    savedPartialPayGlobals = {
      layer: window.advancedPreorderVariantsLayer,
      sellingPlans: window.advancedPreorderVariantSellingPlans,
      sdProductId: window.sd_product_id,
    };
  }

  function restorePartialPayGlobals() {
    if (!savedPartialPayGlobals) return;
    window.advancedPreorderVariantsLayer = savedPartialPayGlobals.layer;
    window.advancedPreorderVariantSellingPlans = savedPartialPayGlobals.sellingPlans;
    window.sd_product_id = savedPartialPayGlobals.sdProductId;
    savedPartialPayGlobals = null;
  }

  function getProductInfo(root) {
    if (!root) return null;
    if (root.matches && root.matches('product-info')) return root;
    return root.querySelector ? root.querySelector('product-info') : null;
  }

  function isQuickViewProductInfo(productInfo) {
    return !!(productInfo && productInfo.closest('quick-add-modal'));
  }

  function getProductForm(productInfo) {
    if (!productInfo) return null;
    return (
      productInfo.querySelector('form[data-type="add-to-cart-form"]') ||
      productInfo.querySelector('product-form form[data-type="add-to-cart-form"]')
    );
  }

  function getVariantId(productInfo, variantId) {
    if (variantId) return String(variantId);
    var input = productInfo && productInfo.querySelector('input[name="id"], input.product-variant-id');
    return input && input.value ? String(input.value) : '';
  }

  function fetchProductData(productInfo) {
    var productId = productInfo && productInfo.dataset.productId;
    if (productId && partialPayProductCache[productId]) {
      return Promise.resolve(partialPayProductCache[productId]);
    }
    var url = productInfo && productInfo.dataset.url;
    if (!url) return Promise.resolve(null);
    return fetch(url.split('?')[0] + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        if (product && product.id) partialPayProductCache[String(product.id)] = product;
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function loadVariantsLayerFromProductHtml(html) {
    if (!html) return [];
    var layer = [];
    var re = /advancedPreorderVariantsLayer\.push\(\s*(\{[\s\S]*?\})\s*\)/g;
    var match;
    while ((match = re.exec(html)) !== null) {
      try {
        layer.push(JSON.parse(match[1].replace(/\r/g, '')));
      } catch (e) {}
    }
    return layer;
  }

  function loadSellingPlansFromProductHtml(html) {
    if (!html) return [];
    var groupNames = {};
    var groupRe = /advancedPreordertotalGroupNames\['([^']+)'\]='([^']+)'/g;
    var groupMatch;
    while ((groupMatch = groupRe.exec(html)) !== null) {
      groupNames[groupMatch[1]] = groupMatch[2];
    }

    var plans = [];
    var blockRe =
      /var allocationFilteredId = '([^']+)';[\s\S]*?advancedPreorderVariantSellingPlans\.push\(\s*(\{[\s\S]*?\})\s*\)/g;
    var match;
    while ((match = blockRe.exec(html)) !== null) {
      var groupName = groupNames[match[1]] || '';
      var objStr = match[2]
        .replace(/advancedPreordertotalGroupNames\[allocationFilteredId\]/g, JSON.stringify(groupName))
        .replace(/\r/g, '');
      try {
        plans.push(JSON.parse(objStr));
      } catch (e) {}
    }
    return plans;
  }

  function fetchPartialPayHtmlData(productInfo) {
    var url = productInfo && productInfo.dataset.url;
    if (!url) return Promise.resolve(null);
    var cacheKey = url.split('?')[0];
    if (partialPayHtmlCache[cacheKey]) return Promise.resolve(partialPayHtmlCache[cacheKey]);

    return fetch(cacheKey)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var data = {
          htmlLayer: loadVariantsLayerFromProductHtml(html),
          sellingPlans: loadSellingPlansFromProductHtml(html),
        };
        partialPayHtmlCache[cacheKey] = data;
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function ensurePartialPayGlobals(product, htmlData) {
    var htmlLayer = htmlData && htmlData.htmlLayer;
    var sellingPlans = htmlData && htmlData.sellingPlans;

    if (htmlLayer && htmlLayer.length) {
      window.advancedPreorderVariantsLayer = htmlLayer;
    } else if (product && product.variants) {
      window.advancedPreorderVariantsLayer = product.variants.map(function (variant) {
        return {
          id: variant.id,
          price: variant.price,
          sku: variant.sku,
          title: variant.title,
          inventory_policy: variant.inventory_policy,
          available: variant.available,
        };
      });
    }

    if (sellingPlans && sellingPlans.length) {
      window.advancedPreorderVariantSellingPlans = sellingPlans;
    }

    if (product && product.id) window.sd_product_id = product.id;
  }

  function applyQuickViewDeveloperScope(productInfo) {
    if (typeof developersetting === 'undefined' || !developersetting) return;
    var form = getProductForm(productInfo);
    if (!form) return;

    getOriginalDeveloperSettings();
    form.classList.add(QUICKVIEW_FORM_CLASS);

    developersetting.formselector = 'quick-add-modal form.' + QUICKVIEW_FORM_CLASS;
    developersetting.buttonselector = '.product-form__submit, button[name="add"]';
    if (originalDeveloperSettings && originalDeveloperSettings.variantselector3) {
      developersetting.variantselector3 = 'quick-add-modal ' + originalDeveloperSettings.variantselector3;
    }
  }

  function withQuickViewScope(productInfo, fn) {
    applyQuickViewDeveloperScope(productInfo);
    fn();
  }

  function deactivateQuickViewPartialPay() {
    document.querySelectorAll('.' + QUICKVIEW_FORM_CLASS).forEach(function (form) {
      form.classList.remove(QUICKVIEW_FORM_CLASS);
    });
    restoreDeveloperSettings();
    restorePartialPayGlobals();
    originalDeveloperSettings = null;
  }

  function callMaincallerForQuickView(variantId) {
    if (!variantId || typeof window.maincaller !== 'function') return;
    var savedMainurl = window.mainurl;
    try {
      // Advanced Preorder maincaller skips AJAX/button logic on /search and other non-collection URLs.
      if (
        typeof window.mainurl === 'string' &&
        !window.mainurl.includes('collections') &&
        !window.mainurl.includes('product') &&
        (typeof pageType === 'undefined' || pageType !== 'home')
      ) {
        window.mainurl = window.mainurl + '/collections';
      }
      window.maincaller(String(variantId));
    } catch (e) {}
    finally {
      if (savedMainurl !== undefined) window.mainurl = savedMainurl;
    }
  }

  function callMaincaller(variantId) {
    if (!variantId || typeof window.maincaller !== 'function') return;
    try {
      window.maincaller(String(variantId));
    } catch (e) {}
  }

  function refreshPartialPay(variantId) {
    callMaincaller(variantId);
  }

  function refreshPartialPayQuickView(root, variantId) {
    var productInfo = getProductInfo(root);
    if (!productInfo || !isQuickViewProductInfo(productInfo)) return Promise.resolve();

    return Promise.all([fetchProductData(productInfo), fetchPartialPayHtmlData(productInfo)]).then(function (results) {
      var product = results[0];
      var htmlData = results[1];
      if (!productInfo.isConnected || !product) return;
      savePartialPayGlobals();
      ensurePartialPayGlobals(product, htmlData);
      var id = getVariantId(productInfo, variantId);
      if (!id) return;
      withQuickViewScope(productInfo, function () {
        callMaincallerForQuickView(id);
      });
    });
  }

  window.__syncQuickViewPartialPay = refreshPartialPayQuickView;
  window.__deactivateQuickViewPartialPayScope = deactivateQuickViewPartialPay;

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target && event.target.closest && event.target.closest('quick-add-modal .sd_preorder');
      if (!button || button.disabled) return;

      var productInfo = button.closest('product-info');
      var form = getProductForm(productInfo);
      if (!form) return;

      applyQuickViewDeveloperScope(productInfo);
      if (typeof window.__syncQuickViewTagProperties === 'function') {
        window.__syncQuickViewTagProperties(
          productInfo,
          form.querySelector('input[name="id"]')?.value
        );
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var productForm = form.closest('product-form');
      if (productForm) {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    },
    true
  );

  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (!PUB_SUB_EVENTS.variantChange) return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      var sectionId = event && event.data && event.data.sectionId;
      var productInfo = sectionId
        ? document.querySelector('product-info[data-section="' + sectionId + '"]')
        : null;

      if (productInfo && isQuickViewProductInfo(productInfo)) {
        refreshPartialPayQuickView(productInfo, variant && variant.id);
        return;
      }
      refreshPartialPay(variant && variant.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();


// Appstle selling_plan lives outside the product <form>, so Dawn FormData omits it.
// Visual (selected dot + Loyalty) is handled by CSS. JS syncs the plan into the
// form /cart/add payload and paints subscription widget prices from allocations
// immediately on variant/plan change — no MutationObserver, no setTimeout repair.
(function () {
  if (window.__appstleSellingPlanSyncBound) return;
  window.__appstleSellingPlanSyncBound = true;

  var lastPlanId = '';
  var lastVariant = null;
  var productCache = null;
  var productCachePromise = null;

  function injectStyles() {
    if (document.getElementById('plantin-appstle-selling-plan-style')) return;
    var style = document.createElement('style');
    style.id = 'plantin-appstle-selling-plan-style';
    style.textContent =
      '#appstle_subscription_widget0 .appstle_subscription_wrapper_option.appstle-active-option .appstle_circle .appstle_dot,' +
      '#appstle_subscription_widget0 .oneTimePurchaseOptionWrapper.appstle-active-option .appstle_circle .appstle_dot,' +
      '#appstle_subscription_widget0 .appstle_one_time_option.appstle-active-option .appstle_circle .appstle_dot{' +
      'transform:scale(1);' +
      '}' +
      '#appstle_subscription_widget0:has(.payAsYouGoPlansDropdownWrapper.appstle-active-option) .appstleLoyaltyTable,' +
      '#appstle_subscription_widget0:has(.appstle_subscription_wrapper_option.appstle-active-option) .appstleLoyaltyTable{' +
      'display:block!important;' +
      '}';
    (document.head || document.documentElement).appendChild(style);
  }

  function isOneTimeActive(widget) {
    return !!(
      widget &&
      widget.querySelector(
        '.oneTimePurchaseOptionWrapper.appstle-active-option, .appstle_one_time_option.appstle-active-option'
      )
    );
  }

  function getWidget() {
    return (
      document.getElementById('appstle_subscription_widget0') ||
      document.querySelector('.appstle_sub_widget, [id^="appstle_subscription_widget"]')
    );
  }

  function getSelectedSellingPlanId() {
    var widget = getWidget();
    if (!widget) {
      var globalChecked = document.querySelector('input[name="selling_plan"]:checked');
      var globalVal = globalChecked && globalChecked.value ? String(globalChecked.value) : '';
      if (globalVal) lastPlanId = globalVal;
      return globalVal;
    }

    if (isOneTimeActive(widget)) {
      lastPlanId = '';
      return '';
    }

    var select = widget.querySelector('select.appstle_select');
    if (select && select.value) {
      lastPlanId = String(select.value);
      return lastPlanId;
    }

    var fromData = widget.getAttribute('data-selected-selling-plan');
    if (fromData) {
      lastPlanId = String(fromData);
      return lastPlanId;
    }

    var checked = widget.querySelector('input[name="selling_plan"]:checked');
    if (checked && checked.value) {
      lastPlanId = String(checked.value);
      return lastPlanId;
    }

    return lastPlanId || '';
  }

  function getSelectedVariantFromDom() {
    var script = document.querySelector('variant-selects script[type="application/json"][data-selected-variant]');
    if (!script) script = document.querySelector('script[type="application/json"][data-selected-variant]');
    if (!script || !script.textContent) return lastVariant;
    try {
      var parsed = JSON.parse(script.textContent);
      if (parsed && parsed.id) lastVariant = parsed;
      return parsed;
    } catch (e) {
      return lastVariant;
    }
  }

  function getProductHandle() {
    var root = document.querySelector('variant-selects[data-product-handle], product-info[data-url], product-info[data-product-handle]');
    if (!root) return '';
    if (root.getAttribute('data-product-handle')) return root.getAttribute('data-product-handle');
    var url = root.getAttribute('data-url') || '';
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function getVariantIdHint(variant) {
    if (variant && variant.id) return variant.id;
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? input.value : null;
  }

  function findVariantInProduct(product, variantId) {
    if (!product || !variantId) return null;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    return null;
  }

  function loadProductCache() {
    if (productCache) return Promise.resolve(productCache);
    if (productCachePromise) return productCachePromise;
    var handle = getProductHandle();
    if (!handle) return Promise.resolve(null);
    productCachePromise = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        productCache = product;
        productCachePromise = null;
        return product;
      })
      .catch(function () {
        productCachePromise = null;
        return null;
      });
    return productCachePromise;
  }

  function getSelectedOptionValues() {
    var values = [];
    document.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (input) {
      if (input.value) values.push(input.value);
    });
    if (values.length) return values;
    document.querySelectorAll('variant-selects select').forEach(function (select) {
      if (select.value) values.push(select.value);
    });
    return values;
  }

  function findVariantByOptions(product, optionValues) {
    if (!product || !optionValues || !optionValues.length) return null;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var options = variant.options || [];
      var match = true;
      for (var j = 0; j < optionValues.length; j++) {
        var optionVal = options[j] != null ? options[j] : variant['option' + (j + 1)];
        if (String(optionVal) !== String(optionValues[j])) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  }

  function resolveVariantWithAllocations(variantOverride) {
    var optionValues = getSelectedOptionValues();
    var variantIdHint = getVariantIdHint(variantOverride);

    function withProduct(product) {
      var fromOptions = findVariantByOptions(product, optionValues);
      var fromId = findVariantInProduct(product, variantIdHint);
      // Prefer options currently checked in the UI — selected-variant JSON lags until section fetch.
      var resolved = fromOptions || variantOverride || fromId || getSelectedVariantFromDom();
      if (resolved) lastVariant = resolved;
      return resolved;
    }

    if (variantOverride && variantOverride.selling_plan_allocations && variantOverride.selling_plan_allocations.length) {
      // Still prefer live option selection when it disagrees with a stale override.
      if (productCache) {
        var live = findVariantByOptions(productCache, optionValues);
        if (live && String(live.id) !== String(variantOverride.id)) {
          lastVariant = live;
          return Promise.resolve(live);
        }
      }
      lastVariant = variantOverride;
      return Promise.resolve(variantOverride);
    }

    if (productCache) return Promise.resolve(withProduct(productCache));

    return loadProductCache().then(function (product) {
      return withProduct(product);
    });
  }

  function getAllocation(variant, planId) {
    if (!variant || !planId) return null;
    var allocations = variant.selling_plan_allocations || [];
    for (var i = 0; i < allocations.length; i++) {
      if (String(allocations[i].selling_plan_id) === String(planId)) return allocations[i];
    }
    return allocations[0] || null;
  }

  function variantPriceCents(variant) {
    if (!variant || variant.price == null || variant.price === '') return 0;
    if (typeof variant.price === 'string' && variant.price.indexOf('.') !== -1) {
      return Math.round(parseFloat(variant.price) * 100);
    }
    return Math.round(Number(variant.price) || 0);
  }

  function moneyValueToCents(value, baseCents) {
    if (value == null || value === '') return 0;
    if (typeof value === 'string' && value.indexOf('.') !== -1) {
      return Math.round(parseFloat(value) * 100);
    }
    var n = Number(value) || 0;
    // Ajax selling-plan values are often currency units; variant.price in .js can be cents.
    if (n > 0 && Math.abs(n) < 10000 && baseCents >= 10000) return Math.round(n * 100);
    return Math.round(n);
  }

  function findSellingPlan(product, planId) {
    if (!product || !planId) return null;
    var groups = product.selling_plan_groups || [];
    for (var g = 0; g < groups.length; g++) {
      var plans = groups[g].selling_plans || [];
      for (var p = 0; p < plans.length; p++) {
        if (String(plans[p].id) === String(planId)) return plans[p];
      }
    }
    return null;
  }

  function computeAllocationFromPlan(variant, plan) {
    if (!variant || !plan) return null;
    var base = variantPriceCents(variant);
    var price = base;
    var adjustments = plan.price_adjustments || [];
    for (var i = 0; i < adjustments.length; i++) {
      var adj = adjustments[i] || {};
      if (adj.value_type === 'percentage') {
        price = Math.round(base - (base * Number(adj.value)) / 100);
      } else if (adj.value_type === 'fixed_amount') {
        price = Math.max(0, base - moneyValueToCents(adj.value, base));
      } else if (adj.value_type === 'price') {
        price = moneyValueToCents(adj.value, base);
      }
    }
    return {
      price: price,
      compare_at_price: base > price ? base : variant.compare_at_price || null,
      selling_plan_id: plan.id,
    };
  }

  function resolveAllocation(variant, planId, product) {
    var allocation = getAllocation(variant, planId);
    if (allocation && allocation.price != null) return allocation;
    var plan = findSellingPlan(product || productCache, planId);
    return computeAllocationFromPlan(variant, plan);
  }

  function formatWidgetMoney(cents, sampleText) {
    var value = Math.max(0, Math.round(Number(cents) || 0));
    var amount = (value / 100).toFixed(2);
    // Match Liquid money formatting (thousand separators). Shopify.formatMoney({{amount}}) drops commas.
    var localized = Number(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    var sample = sampleText || '';
    var format = window.shopMoneyFormat || window.shopMoneyWithCurrencyFormat;

    if (typeof format === 'string' && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value / 100)))
        .replace(/\{\{\s*amount\s*\}\}/g, localized);
    }

    if (/HK\$/i.test(sample)) {
      var hk = 'HK$' + localized;
      if (/\bHKD\b/i.test(sample)) hk += '';
      return hk;
    }
    if (/\$/.test(sample)) return '$' + localized;

    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
      })
        .format(value / 100)
        .replace(/\u00a0/g, ' ');
    } catch (err) {
      return currency + ' ' + localized;
    }
  }

  function setTextIfChanged(el, text) {
    if (!el || text == null || text === '') return;
    if ((el.textContent || '').trim() === String(text).trim()) return;
    el.textContent = text;
  }

  function getThemePriceRoots() {
    return document.querySelectorAll('product-info [id^="price-"], [id^="price-"]');
  }

  function applyThemeProductPrice(priceCents, compareCents) {
    if (priceCents == null) return;

    getThemePriceRoots().forEach(function (priceRoot) {
      if (!priceRoot || priceRoot.closest('quick-add-modal')) return;

      var priceBox = priceRoot.querySelector('.price');
      var sampleEl =
        priceRoot.querySelector('.price__regular .price-item--regular:not(s)') ||
        priceRoot.querySelector('.price__sale .price-item--sale') ||
        priceRoot.querySelector('.price-item--regular');
      var sample = ((sampleEl && sampleEl.textContent) || '').trim();
      var formattedPrice = formatWidgetMoney(priceCents, sample);
      var hasCompare = compareCents != null && Number(compareCents) > Number(priceCents);
      var formattedCompare = hasCompare ? formatWidgetMoney(compareCents, sample) : '';

      priceRoot.querySelectorAll('.price__regular .price-item--regular').forEach(function (el) {
        if (el.tagName === 'S' || el.classList.contains('variant-item__old-price')) return;
        setTextIfChanged(el, formattedPrice);
      });

      priceRoot.querySelectorAll('.price__sale .price-item--sale').forEach(function (el) {
        setTextIfChanged(el, formattedPrice);
      });

      if (hasCompare) {
        priceRoot.querySelectorAll('.price__sale s.price-item--regular, .price__sale .variant-item__old-price').forEach(function (el) {
          setTextIfChanged(el, formattedCompare);
        });
      }

      if (priceBox) {
        if (hasCompare) {
          priceBox.classList.add('price--on-sale');
        } else {
          priceBox.classList.remove('price--on-sale');
        }
      }
    });

    document.querySelectorAll('[data-product-total-price]').forEach(function (el) {
      el.setAttribute('data-unit-price', String(Math.max(0, Math.round(Number(priceCents) || 0))));
    });

    if (typeof window.updateProductTotalPrice === 'function') {
      try {
        window.updateProductTotalPrice();
      } catch (e) {}
    } else {
      document.querySelectorAll('[data-product-total-price]').forEach(function (el) {
        var root = el.closest('product-info');
        var qtyInput = root && root.querySelector('.quantity__input');
        var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        var unit = Math.max(0, Math.round(Number(priceCents) || 0));
        var currency = el.getAttribute('data-currency-code') || '';
        try {
          el.textContent =
            new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: currency,
              currencyDisplay: 'code',
            })
              .format((unit * qty) / 100)
              .replace(/\u00a0/g, ' ') + ' total';
        } catch (err) {}
      });
    }
  }

  // Do not rewrite Appstle widget amounts/labels — leave widget as Appstle renders it.
  // Only sync the theme #price block to the selected plan's allocation total (not monthly ÷).
  function syncThemePriceForSelection(variantOverride) {
    var widget = getWidget();
    var planId = getSelectedSellingPlanId();

    resolveVariantWithAllocations(variantOverride).then(function (variant) {
      if (!variant) return;

      // No Appstle widget: keep Liquid-rendered price (avoids comma flash on normal PDPs).
      if (!widget) return;

      if (isOneTimeActive(widget) || !planId) {
        applyThemeProductPrice(variantPriceCents(variant), variant.compare_at_price);
        return;
      }

      var allocation = resolveAllocation(variant, planId, productCache);
      if (!allocation || allocation.price == null) {
        applyThemeProductPrice(variantPriceCents(variant), variant.compare_at_price);
        return;
      }

      var priceCents = allocation.price;
      var compareCents =
        allocation.compare_at_price != null ? allocation.compare_at_price : variant.compare_at_price;
      applyThemeProductPrice(priceCents, compareCents);
    });
  }

  function syncWidgetSubscriptionPrice(variantOverride) {
    syncThemePriceForSelection(variantOverride);
  }

  function syncFormSellingPlan() {
    var planId = getSelectedSellingPlanId();

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var input = form.querySelector('input[data-plantin-selling-plan="true"]');

      if (!planId) {
        var widget = getWidget();
        if (isOneTimeActive(widget) && input) input.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-plantin-selling-plan', 'true');
        form.appendChild(input);
      }
      input.disabled = false;
      if (input.value !== planId) input.value = planId;
    });

    syncWidgetSubscriptionPrice();
    return planId;
  }

  function mergeSellingPlanIntoPayload(payload, planId) {
    if (!payload || !planId) return payload;

    if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      payload.set('selling_plan', planId);
      return payload;
    }

    if (typeof payload === 'string') {
      try {
        return JSON.stringify(mergeSellingPlanIntoPayload(JSON.parse(payload), planId));
      } catch (e) {
        try {
          var params = new URLSearchParams(payload);
          params.set('selling_plan', planId);
          return params.toString();
        } catch (err) {
          return payload;
        }
      }
    }

    if (typeof payload === 'object') {
      if (Array.isArray(payload.items)) {
        payload.items.forEach(function (item) {
          if (item) item.selling_plan = planId;
        });
        return payload;
      }
      payload.selling_plan = Number(planId) || planId;
    }

    return payload;
  }

  function hookCartAdd() {
    if (window.__appstleSellingPlanCartHooked) return;
    window.__appstleSellingPlanCartHooked = true;
    if (typeof window.fetch !== 'function') return;

    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add/i.test(url)) {
        var planId = syncFormSellingPlan();
        if (planId && init) {
          init = Object.assign({}, init);
          init.body = mergeSellingPlanIntoPayload(init.body, planId);
        }
      }
      return originalFetch(input, init);
    };
  }

  injectStyles();
  hookCartAdd();
  syncFormSellingPlan();
  loadProductCache();

  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target &&
        event.target.closest &&
        event.target.closest('#appstle_subscription_widget0, .appstle_sub_widget, [id^="appstle_subscription_widget"]')
      ) {
        syncFormSellingPlan();
      }
    },
    true
  );

  [
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:cart.remove',
    'rebuy:smartcart.ready',
    'rebuy:cart.ready',
    'AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated',
    'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
    'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
    'AppstleSubscription:SubscriptionWidget:widgetInitialised',
    'appstle_widget_updated',
  ].forEach(function (eventName) {
    document.addEventListener(eventName, syncFormSellingPlan);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    if (PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, syncFormSellingPlan);
    // Paint as soon as the shopper clicks an option — do not wait for Dawn section fetch
    // (variantChange), which is what made Appstle prices feel late (~1s).
    if (PUB_SUB_EVENTS.optionValueSelectionChange) {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
        syncWidgetSubscriptionPrice();
      });
    }
    if (PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant) lastVariant = variant;
        syncFormSellingPlan();
        syncWidgetSubscriptionPrice(variant);
      });
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      if (!event.target || !event.target.closest) return;
      if (event.target.closest('variant-selects, variant-radios, .product-form__input')) {
        syncWidgetSubscriptionPrice();
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    injectStyles();
    hookCartAdd();
    syncFormSellingPlan();
  });
})();


// Rebuy drawer: Estimated Price → item price; inject Appstle selling-plan frequency
// No subtree MutationObserver — that re-fired on our own DOM writes and could freeze the cart.
(function () {
  if (window.__rebuyEstimatedPriceBound) return;
  window.__rebuyEstimatedPriceBound = true;

  var timer;
  var applying = false;
  var attrObserver = null;

  function withMoneyCommas(text) {
    if (typeof window.plantinGroupMoneyText === 'function') return window.plantinGroupMoneyText(text);
    return String(text || '').trim();
  }

  function getEstimatedPrice(item) {
    var props = item.querySelectorAll('.rebuy-cart__flyout-item-property');
    for (var i = 0; i < props.length; i++) {
      var prop = props[i];
      if (prop.classList.contains('rebuy-cart__flyout-item-property--delivery-frequency')) continue;
      var nameEl = prop.querySelector('.rebuy-cart__flyout-item-property-name');
      var valueEl = prop.querySelector('.rebuy-cart__flyout-item-property-value');
      var name = ((nameEl && nameEl.textContent) || '') + ' ' + (prop.className || '');
      if (/estimated\s*price/i.test(name)) {
        return withMoneyCommas(((valueEl && valueEl.textContent) || '').trim());
      }
    }
    return '';
  }

  function getCartItems() {
    if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart && Array.isArray(Rebuy.Cart.cart.items)) {
      return Rebuy.Cart.cart.items;
    }
    return [];
  }

  function getSellingPlanName(cartItem) {
    if (!cartItem || !cartItem.selling_plan_allocation) return '';
    var plan = cartItem.selling_plan_allocation.selling_plan;
    return (plan && plan.name && String(plan.name).trim()) || '';
  }

  function itemProductPath(cartItem) {
    var url = (cartItem && (cartItem.url || cartItem.product_url || '')) || '';
    try {
      if (url.indexOf('http') === 0) url = new URL(url).pathname;
    } catch (e) {}
    return String(url).split('?')[0];
  }

  function findCartItemForEl(itemEl, cartItems) {
    var link = itemEl.querySelector('.rebuy-cart__flyout-item-product-title, .rebuy-cart__flyout-item-media a');
    var href = link && link.getAttribute('href');
    if (!href) return null;
    var path = href.split('?')[0];
    var variantTitleEl = itemEl.querySelector('.rebuy-cart__flyout-item-variant-title');
    var variantTitle = ((variantTitleEl && variantTitleEl.textContent) || '').trim();

    var matches = [];
    for (var i = 0; i < cartItems.length; i++) {
      var cartItem = cartItems[i];
      var itemPath = itemProductPath(cartItem);
      if (itemPath && path && (itemPath === path || path.indexOf(itemPath) !== -1 || itemPath.indexOf(path) !== -1)) {
        matches.push(cartItem);
      }
    }
    if (matches.length === 1) return matches[0];
    if (matches.length > 1 && variantTitle) {
      for (var j = 0; j < matches.length; j++) {
        if (String(matches[j].variant_title || '').trim() === variantTitle) return matches[j];
      }
    }
    return matches[0] || null;
  }

  function ensureFrequencyEl(itemEl, planName) {
    var propsWrap = itemEl.querySelector('.rebuy-cart__flyout-item-properties');
    var freq = itemEl.querySelector('.rebuy-cart__flyout-item-property--delivery-frequency');

    if (!planName) {
      if (freq && freq.dataset.plantinInjected === 'true') freq.remove();
      if (
        propsWrap &&
        propsWrap.dataset.plantinInjected === 'true' &&
        !propsWrap.querySelector('.rebuy-cart__flyout-item-property')
      ) {
        propsWrap.remove();
      }
      return;
    }

    if (freq && freq.textContent === planName) return;

    if (!propsWrap) {
      propsWrap = document.createElement('div');
      propsWrap.className = 'rebuy-cart__flyout-item-properties';
      propsWrap.dataset.plantinInjected = 'true';
      var info = itemEl.querySelector('.rebuy-cart__flyout-item-info');
      var variant = info && info.querySelector('.rebuy-cart__flyout-item-variant-title');
      if (variant && variant.parentNode) {
        variant.parentNode.insertBefore(propsWrap, variant.nextSibling);
      } else if (info) {
        info.appendChild(propsWrap);
      } else {
        itemEl.appendChild(propsWrap);
      }
    }

    if (!freq) {
      freq = document.createElement('div');
      freq.className =
        'rebuy-cart__flyout-item-property rebuy-cart__flyout-item-property--delivery-frequency';
      freq.dataset.plantinInjected = 'true';
      propsWrap.insertBefore(freq, propsWrap.firstChild);
    }

    if (freq.textContent !== planName) freq.textContent = planName;
  }

  function applyEstimatedPrices() {
    if (applying) return;
    applying = true;

    try {
      var cartItems = getCartItems();

      document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item').forEach(function (item, index) {
        var cartItem = findCartItemForEl(item, cartItems) || cartItems[index];
        ensureFrequencyEl(item, getSellingPlanName(cartItem));

        var estimated = getEstimatedPrice(item);
        var priceWrap = item.querySelector('.rebuy-cart__flyout-item-price');
        var custom = priceWrap && priceWrap.querySelector('.rebuy-estimated-price');

        if (!estimated) {
          if (item.classList.contains('has-estimated-price')) item.classList.remove('has-estimated-price');
          if (custom) custom.remove();
          return;
        }

        if (!item.classList.contains('has-estimated-price')) item.classList.add('has-estimated-price');
        if (!priceWrap) return;

        if (!custom) {
          custom = document.createElement('span');
          custom.className = 'rebuy-estimated-price estimated-price';
          priceWrap.appendChild(custom);
        }
        var labeled = '<span class="estimated-price-value">' + estimated + '</span>';
        if (custom.innerHTML !== labeled) custom.innerHTML = labeled;
      });
    } finally {
      applying = false;
    }
  }

  function schedule() {
    if (applying) return;
    clearTimeout(timer);
    timer = setTimeout(applyEstimatedPrices, 80);
  }

  // Rebuy sometimes paints items a beat after the event — one follow-up pass, no observer loop
  function scheduleWithRetry() {
    schedule();
    setTimeout(schedule, 250);
    setTimeout(schedule, 600);
  }

  function bindCartOpenWatcher() {
    var cart = document.getElementById('rebuy-cart');
    if (!cart || cart.dataset.estimatedPriceAttrObserved === 'true') return;
    cart.dataset.estimatedPriceAttrObserved = 'true';

    // Only watch class (open/close) — never subtree, so our injects cannot re-trigger
    attrObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class') {
          scheduleWithRetry();
          break;
        }
      }
    });
    attrObserver.observe(cart, { attributes: true, attributeFilter: ['class'] });
  }

  [
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:cart.remove',
    'rebuy:smartcart.ready',
    'rebuy:cart.ready',
    'rebuy:smartcart.show',
    'rebuy:smartcart.opened'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      bindCartOpenWatcher();
      scheduleWithRetry();
    });
  });

  document.addEventListener(
    'click',
    function (event) {
      // Only refresh on open trigger — not on close (avoids fighting Rebuy hide animation)
      var trigger =
        event.target &&
        event.target.closest &&
        event.target.closest('#cart-icon-bubble, [data-rebuy-cart-toggle]');
      if (trigger) scheduleWithRetry();
    },
    true
  );

  bindCartOpenWatcher();
  scheduleWithRetry();
})();


// Rebuy Smart Cart + Dawn cart-drawer conflict:
// Cart icon opens BOTH → Dawn leaves body.overflow-hidden after Rebuy closes → page feels stuck.
(function () {
  if (window.__rebuyDawnCartGuardBound) return;
  window.__rebuyDawnCartGuardBound = true;

  function hasRebuyCart() {
    return !!(document.getElementById('rebuy-cart') || document.body.classList.contains('smart-cart--enabled'));
  }

  function isRebuyOpen() {
    var cart = document.getElementById('rebuy-cart');
    return !!(cart && cart.classList.contains('is-visible'));
  }

  function closeDawnDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('active', 'animate');
      // Clear Dawn focus trap only — do NOT focus #cart-icon-bubble (that steals
      // focus on every Rebuy open/close/class sync and makes the cart icon flash).
      if (typeof removeTrapFocus === 'function') {
        try {
          removeTrapFocus();
        } catch (e) {}
      }
    }
    if (!isRebuyOpen()) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  function patchDawnOpen() {
    var Ctor = customElements.get('cart-drawer');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__rebuyPatched) return;
    var originalOpen = Ctor.prototype.open;
    Ctor.prototype.open = function () {
      if (hasRebuyCart()) {
        // Keep Dawn closed; Rebuy owns the flyout
        closeDawnDrawer();
        return;
      }
      return originalOpen.apply(this, arguments);
    };
    Ctor.prototype.__rebuyPatched = true;
  }

  function syncOnRebuyClassChange() {
    if (isRebuyOpen()) {
      closeDawnDrawer(); // ensure Dawn isn't also active underneath
      return;
    }
    closeDawnDrawer();
  }

  function bindRebuySync() {
    var cart = document.getElementById('rebuy-cart');
    if (!cart || cart.dataset.dawnCartSyncObserved === 'true') return;
    cart.dataset.dawnCartSyncObserved = 'true';

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class') {
          syncOnRebuyClassChange();
          break;
        }
      }
    }).observe(cart, { attributes: true, attributeFilter: ['class'] });
  }

  patchDawnOpen();
  bindRebuySync();

  [
    'rebuy:smartcart.hide',
    'rebuy:smartcart.closed',
    'rebuy:smartcart.close',
    'rebuy:cart.ready',
    'rebuy:smartcart.ready'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      patchDawnOpen();
      bindRebuySync();
      // After hide animation / class flip
      setTimeout(syncOnRebuyClassChange, 50);
      setTimeout(syncOnRebuyClassChange, 300);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchDawnOpen();
      bindRebuySync();
      closeDawnDrawer();
    });
  } else {
    closeDawnDrawer();
  }
})();


// rebuy checkout button
document.addEventListener('DOMContentLoaded', function () {
  var timer;
  var observer;
  var updating = false;

  function updateRebuyCartButton() {
    if (updating) return;
    updating = true;
    if (observer) observer.disconnect();

    try {
      document.querySelectorAll('.rebuy-cart__view-cart-button').forEach(function (button) {
        if (button.classList.contains('custom-view-cart-button')) return;

        button.classList.add('custom-view-cart-button', 'button');

        button.innerHTML = `
        <span>VIEW CART & CHECKOUT</span>
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3 6L13 6"
            stroke="rgb(var(--color-button-text))"
            stroke-width="0.999933"
            stroke-linecap="round"
            stroke-linejoin="round">
          </path>

          <path
            d="M10 2.5L13.4998 5.99977L10 9.49953"
            stroke="rgb(var(--color-button-text))"
            stroke-width="0.999933"
            stroke-linecap="round"
            stroke-linejoin="round">
          </path>
        </svg>
      `;
      });
    } finally {
      updating = false;
      var cart = document.getElementById('rebuy-cart');
      if (observer && cart) {
        observer.observe(cart, { childList: true, subtree: true });
      }
    }
  }

  function schedule() {
    if (updating) return;
    clearTimeout(timer);
    timer = setTimeout(updateRebuyCartButton, 100);
  }

  updateRebuyCartButton();

  var cart = document.getElementById('rebuy-cart');
  observer = new MutationObserver(schedule);
  if (cart) {
    observer.observe(cart, { childList: true, subtree: true });
  }

  ['rebuy:smartcart.ready', 'rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:smartcart.show'].forEach(function (eventName) {
    document.addEventListener(eventName, schedule);
  });
});
// rebuy checkout close


// Rebuy cart → header count bubble
(function () {
  if (window.__rebuyHeaderCartBubbleBound) return;
  window.__rebuyHeaderCartBubbleBound = true;

  var debounceTimer;
  var isRefreshing = false;

  function getCartFromEvent(event) {
    var detail = event && event.detail;
    if (detail && detail.cart && detail.cart.cart) return detail.cart.cart;
    if (detail && detail.cart && typeof detail.cart.item_count === 'number') return detail.cart;
    if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart) return Rebuy.Cart.cart;
    return null;
  }

  function applyOptimisticCount(itemCount) {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink || typeof itemCount !== 'number') return;

    var bubble = cartLink.querySelector('.cart-count-bubble');
    if (itemCount <= 0) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) return;
    var visibleCount = bubble.querySelector('[aria-hidden="true"]');
    if (visibleCount) visibleCount.textContent = String(itemCount);
  }

  function refreshHeaderCartBubble() {
    if (isRefreshing || !window.routes || !routes.cart_url) return Promise.resolve();
    isRefreshing = true;

    return fetch(routes.cart_url + '?section_id=cart-icon-bubble')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var source = parsed.querySelector('.shopify-section');
        var dest = document.getElementById('cart-icon-bubble');
        if (source && dest) dest.innerHTML = source.innerHTML;
      })
      .catch(function () {})
      .finally(function () {
        isRefreshing = false;
      });
  }

  window.__refreshHeaderCartBubble = refreshHeaderCartBubble;

  function onRebuyCartChange(event) {
    var cart = getCartFromEvent(event);
    if (cart && typeof cart.item_count === 'number') {
      applyOptimisticCount(cart.item_count);
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refreshHeaderCartBubble, 150);
  }

  [
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:cart.remove',
    'rebuy.change',
    'rebuy:smartcart.ready',
  ].forEach(function (eventName) {
    document.addEventListener(eventName, onRebuyCartChange);
  });
})();


// restock title start
(function () {
  function moveProductTitle() {
    const title = document.querySelector('#form-Product-Name');
    const description = document.querySelector('#form-Description');

    if (!title || !description) return;

    // Description ke upar title move karein
    if (description.previousElementSibling !== title) {
      description.parentNode.insertBefore(title, description);
    }
  }

  // Initial check
  moveProductTitle();

  // STOQ modal dynamically load hone par
  const observer = new MutationObserver(function () {
    moveProductTitle();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
// restock title close


// NEW: Smooth scroll for any anchor link with #
$(document).ready(function () {
  $('a[href^="#"]').on('click', function (e) {
    var target = $(this).attr('href');

    // Skip empty hashes
    if (target === '#' || !$(target).length) return;

    e.preventDefault();

    var headerHeight = $('.header-wrapper').outerHeight() || 0;
    var scrollOffset = headerHeight + 50;

    $('html, body').stop().animate({
      scrollTop: $(target).offset().top - scrollOffset
    }, 600);
  });
});

// Sync Smooth scroll to mobile drop down on FAQ page
document.addEventListener('DOMContentLoaded', function () {
  const select = document.querySelector('.faq__filter-select');

  if (!select) return;

  select.addEventListener('change', function () {
    const link = document.querySelector(
      '.faq__filters a[href="' + this.value + '"]'
    );

    if (link) {
      link.click();
    }
  });
});

// Recipe Kit layout (match demo rk_card structure):
// - Header: title+actions inside details; meta below secondary (full width)
// - Body: cart actions inside ingredients (after ingredient list), not between columns
(function () {
  if (window.__rkHeaderLayoutBound) return;
  window.__rkHeaderLayoutBound = true;

  var timer;
  var observer = null;
  var observedRoot = null;

  function isRecipeKitLayoutReady(card) {
    var header = card.querySelector('.rk_header');
    var secondary = header && header.querySelector('.rk_grid.rk_secondary');
    var details = secondary && secondary.querySelector('.rk_details');
    var titleInDetails = !!(details && details.querySelector('#rk-recipe'));
    var meta = header && header.querySelector('.rk_grid[aria-label="Recipe information"]');
    var metaAfterSecondary = !!(meta && secondary && secondary.nextElementSibling === meta);
    var ingredients = card.querySelector('.rk_ingredients');
    var cartActions = card.querySelector('.rk_cart_actions');
    var list = null;
    if (ingredients) {
      for (var i = 0; i < ingredients.children.length; i++) {
        if (ingredients.children[i].tagName === 'UL') {
          list = ingredients.children[i];
          break;
        }
      }
    }
    var cartInPlace =
      !cartActions ||
      !ingredients ||
      (cartActions.parentElement === ingredients &&
        (!list || list.nextElementSibling === cartActions || ingredients.lastElementChild === cartActions));
    return !!(titleInDetails && metaAfterSecondary && cartInPlace);
  }

  function disconnectObserver() {
    if (!observer) return;
    observer.disconnect();
  }

  function observeRoot(root) {
    if (!observer || !root) return;
    observedRoot = root;
    observer.observe(root, { childList: true, subtree: true });
  }

  function reorderRecipeKitLayout(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.rk_card').forEach(function (card) {
      var header = card.querySelector('.rk_header');
      if (header) {
        var secondary = null;
        var titleGrid = null;
        Array.prototype.forEach.call(header.children, function (child) {
          if (!child.classList || !child.classList.contains('rk_grid')) return;
          if (child.classList.contains('rk_secondary')) {
            secondary = child;
            return;
          }
          if (
            child.getAttribute('aria-label') !== 'Recipe information' &&
            child.querySelector('.rk_primary, .rk_heading, #rk-recipe')
          ) {
            titleGrid = child;
          }
        });

        if (secondary) {
          var details = secondary.querySelector('.rk_details');
          if (details) {
            var meta =
              details.querySelector('.rk_grid[role="region"][aria-label="Recipe information"]') ||
              (function () {
                for (var i = 0; i < header.children.length; i++) {
                  var child = header.children[i];
                  if (
                    child.classList &&
                    child.classList.contains('rk_grid') &&
                    child.getAttribute('aria-label') === 'Recipe information'
                  ) {
                    return child;
                  }
                }
                return null;
              })();

            if (titleGrid && (titleGrid.parentElement !== details || details.firstElementChild !== titleGrid)) {
              details.insertBefore(titleGrid, details.firstChild);
            }

            if (meta && (meta.parentElement === details || secondary.nextElementSibling !== meta)) {
              secondary.insertAdjacentElement('afterend', meta);
            }
          }
        }
      }

      // Demo: .rk_cart_actions is last child of .rk_ingredients (after ul)
      var ingredients = card.querySelector('.rk_ingredients');
      var cartActions =
        (ingredients && ingredients.querySelector('.rk_cart_actions')) ||
        card.querySelector('.rk_body > .rk_cart_actions') ||
        card.querySelector('.rk_cart_actions');
      if (ingredients && cartActions) {
        var list = null;
        for (var i = 0; i < ingredients.children.length; i++) {
          if (ingredients.children[i].tagName === 'UL') {
            list = ingredients.children[i];
            break;
          }
        }
        var alreadyCorrect =
          cartActions.parentElement === ingredients &&
          (!list || list.nextElementSibling === cartActions || ingredients.lastElementChild === cartActions);
        if (!alreadyCorrect) {
          if (list) {
            list.insertAdjacentElement('afterend', cartActions);
          } else {
            ingredients.appendChild(cartActions);
          }
        }
      }
    });
  }

  function schedule(scope) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      // Pause observer while we move nodes (avoids mutate → schedule loops)
      disconnectObserver();
      reorderRecipeKitLayout(scope || document);

      var root =
        (scope && scope.nodeType === 1 ? scope : null) ||
        observedRoot ||
        document.getElementById('rk_parent') ||
        document.querySelector('recipe-kit');
      if (!root) return;

      var cards = root.querySelectorAll('.rk_card');
      var ready = cards.length > 0;
      for (var i = 0; i < cards.length; i++) {
        if (!isRecipeKitLayoutReady(cards[i])) {
          ready = false;
          break;
        }
      }

      // Layout settled → stay disconnected. Still mounting → keep watching.
      if (!ready) observeRoot(root);
    }, 50);
  }

  function bindObserver() {
    var parent = document.getElementById('rk_parent') || document.querySelector('recipe-kit');
    if (!parent) return;

    if (!observer) {
      observer = new MutationObserver(function () {
        schedule(parent);
      });
    }

    if (parent.dataset.rkLayoutObserved !== 'true') {
      parent.dataset.rkLayoutObserved = 'true';
    }

    observeRoot(parent);
  }

  schedule();
  bindObserver();
  document.addEventListener('DOMContentLoaded', function () {
    schedule();
    bindObserver();
  });
  document.addEventListener('shopify:section:load', function () {
    var parent = document.getElementById('rk_parent') || document.querySelector('recipe-kit');
    if (parent) delete parent.dataset.rkLayoutObserved;
    schedule();
    bindObserver();
  });
})();


// PickEasy: when date is set and time is empty, select 06:00 AM via the real
// time-slot radio (input.value alone does not update PickEasy state / cart attrs).
(function () {
  if (window.__pickeasyDefaultTimeBound) return;
  window.__pickeasyDefaultTimeBound = true;

  var DEFAULT_TIME = '06:00 AM';
  var selecting = false;

  function timeInput() {
    return document.getElementById('neo-input-time');
  }

  function isEmptyTime() {
    var el = timeInput();
    if (!el || el.disabled) return true;
    var v = String(el.value || '').trim();
    return !v || /^select time$/i.test(v);
  }

  function queryRadios() {
    var list = Array.prototype.slice.call(
      document.querySelectorAll('.neo-time-radio-group input[type="radio"], input[type="radio"][name="timeSlot"]')
    );
    document.querySelectorAll('pickeasy-slot-picker, pickeasy-app-widget').forEach(function (host) {
      if (!host.shadowRoot) return;
      list = list.concat(
        Array.prototype.slice.call(
          host.shadowRoot.querySelectorAll(
            '.neo-time-radio-group input[type="radio"], input[type="radio"][name="timeSlot"]'
          )
        )
      );
    });
    return list;
  }

  function findDefaultRadio(radios) {
    var i;
    var val;
    var text;
    var label;
    for (i = 0; i < radios.length; i++) {
      val = String(radios[i].value || '').trim();
      if (val === DEFAULT_TIME) return radios[i];
    }
    for (i = 0; i < radios.length; i++) {
      label = radios[i].closest('label');
      text = label ? String(label.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (text === DEFAULT_TIME || text.indexOf('06:00') === 0) return radios[i];
    }
    return radios[0] || null;
  }

  function selectDefaultTimeRadio() {
    if (selecting) return false;
    if (!isEmptyTime()) return true;

    var radios = queryRadios();
    if (!radios.length) return false;

    var target = findDefaultRadio(radios);
    if (!target) return false;

    selecting = true;
    try {
      // Native click so Stencil onChange -> setSelectedTimeAndClose(value) runs.
      target.click();
      return !isEmptyTime() || !!target.checked;
    } finally {
      setTimeout(function () {
        selecting = false;
      }, 500);
    }
  }

  function openTimeAndSelectDefault() {
    if (selecting) return;
    if (!isEmptyTime()) return;

    var el = timeInput();
    if (!el || el.disabled) return;

    // Open the time popup so radios mount in the DOM.
    if (!queryRadios().length) el.click();

    var attempts = 0;
    (function trySelect() {
      attempts += 1;
      if (selectDefaultTimeRadio()) return;
      if (attempts < 25) setTimeout(trySelect, 60);
    })();
  }

  function onSlotUpdate(event) {
    if (selecting) return;
    var detail = (event && event.detail) || {};
    if (!detail.date) return;
    // After date pick (or initial load), timeSlot is often empty / isPartial.
    if (detail.timeSlot) return;
    setTimeout(openTimeAndSelectDefault, 100);
  }

  document.addEventListener('slotUpdate', onSlotUpdate, true);
  document.addEventListener('pickeasyWidgetLoaded', function () {
    setTimeout(openTimeAndSelectDefault, 250);
  });

  function boot() {
    if (!document.getElementById('neo-input-date')) return;
    if (!isEmptyTime()) return;
    setTimeout(openTimeAndSelectDefault, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(boot, 800);
    });
  } else {
    setTimeout(boot, 800);
  }
})();
